// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

import type { ComponentInterface } from '@stencil/core'
import { AttachInternals, Component, h } from '@stencil/core'

/**
 * The `<qds-table-row>` element defines a row of cells in a table. The row's
 * cells can then be established using a mix of `<qds-table-cell>` (data cell)
 * and `<qds-table-head-cell>` (header cell) elements.
 *
 * @see https://quartz.se.com/build/components/table
 */
@Component({
  tag: 'qds-table-row',
  shadow: true,
  styleUrl: 'table-row.css',
})
export class TableRow implements ComponentInterface {
  @AttachInternals() private readonly internals!: ElementInternals

  public componentWillLoad(): void {
    this.internals.role = 'row'
  }

  // eslint-disable-next-line @typescript-eslint/class-methods-use-this
  public render() {
    return (
      <tr class="qds-table-row" role="none">
        <slot />
      </tr>
    )
  }
}
